import { GetterTree } from 'vuex'
import { RootState } from '@/store/types'
import {
  ConsultoryItem,
  ConsultoryState,
  ModuleScheduleItem,
  State,
  ModuleScheduleTime
} from '@/store/consultories/types'

interface Group {
  key: string
  value: Array<ModuleScheduleItem>
}

const groupBy = function (xs: Array<any>, key: string): Group {
  return xs.reduce(function (rv, x) {
    // eslint-disable-next-line prettier/prettier
    (rv[x[key]] = rv[x[key]] || []).push(x)
    return rv
  }, {})
}

function parseTime(time: number): string {
  const strNumber: string = time.toString()
  return strNumber.length == 1 ? `0${time}` : `${time}`
}

export const getters: GetterTree<ConsultoryState, RootState> = {
  getApprovedConsultories(state: ConsultoryState): Array<ConsultoryItem> {
    return state.consultoriesList.filter(
      item => item.lumineStatus == State.Approved
    )
  },

  getNotApprovedConsultories(state: ConsultoryState): Array<ConsultoryItem> {
    return state.consultoriesList.filter(
      item => item.lumineStatus != State.Approved
    )
  },

  getDaySchedule(state: ConsultoryState): Array<ModuleScheduleTime> {
    const moduleScheduleTimes: Array<ModuleScheduleTime> = []

    const days = Object.entries(groupBy(state.moduleSchedule, 'dayOfWeek'))

    days.forEach(element => {
      const group: Array<ModuleScheduleItem> = element[1].sort(
        (a: ModuleScheduleItem, b: ModuleScheduleItem) =>
          a.order > b.order ? 1 : -1
      )
      console.log(group)
      const hasOne = group.length > 0
      const hasTwo = group.length > 1
      moduleScheduleTimes.push({
        day: hasOne ? group[0].dayName : '- - -',
        morningHours: hasOne
          ? `${parseTime(group[0].startDateHour)}:${parseTime(
              group[0].startDateMinute
            )} - ${parseTime(group[0].endDateHour)}:${parseTime(
              group[0].endDateMinute
            )}`
          : '- - -',
        eveningHours: hasTwo
          ? `${parseTime(group[1].startDateHour)}:${parseTime(
              group[1].startDateMinute
            )} - ${parseTime(group[1].endDateHour)}:${parseTime(
              group[1].endDateMinute
            )}`
          : '- - -',
        isEnabled: group[0].isEnabled
      } as ModuleScheduleTime)
    })

    return moduleScheduleTimes
  }
}
